export default __webpack_public_path__ + "device_indoor_cam_2.92b4d51a.png";